import * as React from "react";
import { SVGProps } from "react";
export const MinusCircleFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.70799 10.875H13.312C13.5487 10.875 13.7503 10.7883 13.917 10.615C14.0837 10.441 14.167 10.236 14.167 10C14.167 9.76401 14.08 9.55901 13.906 9.38501C13.7327 9.21167 13.528 9.12501 13.292 9.12501H6.68799C6.45133 9.12501 6.24966 9.21167 6.08299 9.38501C5.91633 9.55901 5.83299 9.76401 5.83299 10C5.83299 10.236 5.91999 10.441 6.09399 10.615C6.26733 10.7883 6.47199 10.875 6.70799 10.875ZM9.99999 18.333C8.84733 18.333 7.76399 18.1143 6.74999 17.677C5.73599 17.2397 4.85399 16.646 4.10399 15.896C3.35399 15.146 2.76033 14.264 2.32299 13.25C1.88566 12.236 1.66699 11.1527 1.66699 10C1.66699 8.84734 1.88566 7.76401 2.32299 6.75001C2.76033 5.73601 3.35399 4.85401 4.10399 4.10401C4.85399 3.35401 5.73599 2.76034 6.74999 2.32301C7.76399 1.88567 8.84733 1.66701 9.99999 1.66701C11.1527 1.66701 12.236 1.88567 13.25 2.32301C14.264 2.76034 15.146 3.35401 15.896 4.10401C16.646 4.85401 17.2397 5.73601 17.677 6.75001C18.1143 7.76401 18.333 8.84734 18.333 10C18.333 11.1527 18.1143 12.236 17.677 13.25C17.2397 14.264 16.646 15.146 15.896 15.896C15.146 16.646 14.264 17.2397 13.25 17.677C12.236 18.1143 11.1527 18.333 9.99999 18.333Z"
            fill="currentColor"
        />
    </svg>
);
MinusCircleFillIcon.displayName = "MinusCircleFillIcon";
